// redux/user/publicProfile/userPublicProfileThunks.js

import { createAsyncThunk } from "@reduxjs/toolkit";
import UserPublicProfileAPI from "./userPublicProfileAPI";

/**
 * Fetch public profile by ID or slug.
 * Usage: dispatch(fetchPublicProfile({ idOrSlug }))
 */
export const fetchPublicProfile = createAsyncThunk(
  "profilepublic/fetchByIdOrSlug",
  async ({ idOrSlug }, { rejectWithValue, signal }) => {
    try {
      if (idOrSlug === undefined || idOrSlug === null || idOrSlug === "") {
        throw new Error("idOrSlug is required");
      }
      const data = await UserPublicProfileAPI.fetchByIdOrSlug(idOrSlug, signal);
      return data;
    } catch (err) {
      // Normalize error message
      const message =
        err?.response?.data?.detail ||
        err?.message ||
        "Failed to fetch public profile";
      return rejectWithValue(message);
    }
  }
);

/**
 * Search public users by query string (delegates to /api/v1/search/).
 * Usage: dispatch(searchPublicUsers({ query }))
 */
export const searchPublicUsers = createAsyncThunk(
  "profilepublic/searchUsers",
  async ({ query }, { rejectWithValue, signal }) => {
    try {
      if (!query || !query.trim()) return [];
      const data = await UserPublicProfileAPI.searchPublicUsers(
        query.trim(),
        signal
      );
      return data;
    } catch (err) {
      const message =
        err?.response?.data?.detail ||
        err?.message ||
        "Failed to search users";
      return rejectWithValue(message);
    }
  }
);
